import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=0f16ac2f&scoped=true&"
import script from "./ChatDialog.vue?vue&type=script&lang=js&"
export * from "./ChatDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChatDialog.vue?vue&type=style&index=0&id=0f16ac2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f16ac2f",
  null
  
)

export default component.exports